import React from 'react';

import { bemBlock, Header, Layout } from '@neptune/shared/venus-ui';

import './ProjectHeader.less';

type ProjectHeaderProps = {
  tabs: React.ReactNode;
  headerContent?: React.ReactNode;
  additionalElementRef?: React.ForwardedRef<HTMLElement>;
  lbViewPicker?: React.ReactNode;
  colorListPicker?: React.ReactNode;
  singleRunEmblem?: React.ReactNode;
  singleRunMenu?: React.ReactNode;
  singleRunStatus?: React.ReactNode;
};

const block = bemBlock('project-header');

export const ProjectHeader: React.FC<ProjectHeaderProps> = ({
  tabs,
  headerContent,
  additionalElementRef,
  lbViewPicker,
  colorListPicker,
  singleRunEmblem,
  singleRunMenu,
  singleRunStatus,
}) => {
  return (
    <Header justifyContent="center" data-role="project-header" className={block()}>
      <Layout.Row alignItems="start" spacedChildren="sm" overflow="hidden">
        {headerContent ?? <Header.Title>Runs</Header.Title>}
      </Layout.Row>
      <Layout.Row alignItems="center" spacedChildren="xl" justifyContent="space-between">
        <Layout.Row spacedChildren="md" alignItems="center">
          {tabs}
          {/* content rendered with React.Portal */}
          {additionalElementRef && <Layout.Element elementRef={additionalElementRef} />}
          {singleRunStatus}
          {singleRunEmblem}
          {singleRunMenu}
          {lbViewPicker}
          {colorListPicker}
        </Layout.Row>
      </Layout.Row>
    </Header>
  );
};
